import SC from 'styled-components'

export const Container = SC.div<{ rounded: boolean; shadowed: boolean; stretch: boolean }>`
  overflow: hidden;
  background: #fff;
  min-width: ${(p) => (p.stretch ? '600px' : '0')};
  border-radius: ${(p) => (p.rounded ? '8px' : '0')};
  box-shadow: ${(p) => (p.shadowed ? '0 7px 21px 0 rgba(0, 0, 0, 0.11);' : 'none')};
`
